import React from "react";
// @ts-ignore
import "./index.css";
import service from "../../../../services/api.service";
import Moment from "moment";
import { AuthenticationService } from "../../../../services/auth.service";
import DangerModal from "../../../modal/danger";
import { Opportunity } from "../../../../model/opportunity.model";
import { t } from "../../../../translations/translation.service";
import { ReactComponent as AttachmentIcon } from "../../../../images/icons/attachment.svg";
// @ts-ignore
import ReactFilestack from "filestack-react";
import { AlertService } from "../../../../services/alert.service";
import { Avatar } from "@zendeskgarden/react-avatars";
import avatar from "../../../../images/avatar.jpg";

const dateFormat = "HH:mm - DD/MM/YYYY ";

class CommentComponent extends React.Component<{ opportunity: Opportunity }> {
  state = {
    comment: "",
    comments: [] as Array<any>,
    user: undefined as any,
    currentEditId: undefined,
    currentEditMessage: undefined,
    isModalVisible: false,
    disableButton: false,
    files: [] as any[],
    policyString: "",
    signatureString: "",
    loadingComments: false,
  };

  constructor(props: { opportunity: Opportunity }) {
    super(props);
    this.addComment = this.addComment.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
  }

  onModalClose = () => this.setState({ isModalVisible: false });
  
  async componentDidMount() {
    await Promise.all([this.loadComments(), this.loadFilestackSecurity()]);
  }

  async componentDidUpdate(prevProps: { opportunity: Opportunity }) {
    const prevId = prevProps.opportunity?.id;
    const currentId = this.props.opportunity?.id;

    if (prevId !== currentId) {
      await this.loadComments();
    }

    const prevCommentsLength =
      ((prevProps.opportunity as any)?.comments || []).length || 0;

    const currentCommentsLength =
      ((this.props.opportunity as any)?.comments || []).length || 0;

    if (prevId === currentId && prevCommentsLength !== currentCommentsLength) {
      await this.loadComments();
    }
  }

  async loadFilestackSecurity() {
    try {
      const FilestackService = (
        await import("../../../../services/filestack.service")
      ).default;

      const policyAndSignature = await FilestackService.getPoliceAndSignature();

      this.setState({
        policyString: String(policyAndSignature.data.policy || ""),
        signatureString: String(policyAndSignature.data.signature || ""),
      });
    } catch (err) {
      console.log("ERROR FILESTACK:", err);

      AlertService.error(t("Erro ao carregar upload."));
    }
  }

  async loadComments() {
    const opportunity: any = this.props.opportunity;
    if (!opportunity?._id) {
      return;
    }

    this.setState({
      loadingComments: true,
    });

    try {
      const FileStackService = (
        await import("../../../../services/filestack.service")
      ).default;


      const comments = await Promise.all(
        (opportunity?.comments || []).map(async (comment: any) => {
        
          let policyAndSignature = null;

          if (comment.user?.userImageUrl) {
            try {
              const secure =
                await FileStackService.getFileStackSecreteCodeToUser(
                  comment.user.userImageUrl,
                  false,
                );

              policyAndSignature = secure.data;

            } catch (err) {
              console.log("[USER IMAGE] Erro ao assinar imagem:", err);
            }
          }

          const attachments = await Promise.all(
            (comment.attachments || []).map(async (file: any) => {
              if (file.policyAndSignature) {
                return file;
              }

              try {
                const secure =
                  await FileStackService.getFileStackSecreteCodeToUser(
                    file.url,
                    false,
                  );

                return {
                  ...file,
                  policyAndSignature: secure.data,
                };
              } catch (err) {
                console.log("[FILE] Erro ao gerar assinatura:", err);
                return file;
              }
            }),
          );

          return {
            ...comment,
            user: {
              ...comment.user,
              policyAndSignature,
            },
            attachments,
          };
        }),
      );

      this.setState({
        comments,
        loadingComments: false,
      });

    } catch (err) {
      console.error("[COMMENTS] LOAD COMMENTS ERROR:", err);
      this.setState({
        loadingComments: false,
      });

      AlertService.error(t("Erro ao carregar comentários."));
    }
  }
  handleCommentChange(event: any) {
    this.setState({ comment: event.target.value });
  }

  editComment(comment: any) {
    this.setState({
      currentEditId: comment._id,
      currentEditMessage: comment.message,
    });
  }

  async getSecureFiles(filesUploaded: any[]) {
    const FileStackService = (
      await import("../../../../services/filestack.service")
    ).default;

    return Promise.all(
      filesUploaded.map(async (item: any) => {
        const response = await FileStackService.getFileStackSecreteCodeToUser(
          item.url,
          false,
        );

        const extension = item.mimetype?.split("/")[1] || "file";

        return {
          filename: item.filename?.trim() || `arquivo.${extension}`,
          url: item.url,
          mimetype: item.mimetype,
          handle: item.handle,
          policyAndSignature: response.data,
        };
      }),
    );
  }

  setUrlFile(url: string, policyAndSignature: any): string {
    if (!policyAndSignature) {
      return url;
    }

    if (typeof policyAndSignature === "string") {
      if (!policyAndSignature.trim()) {
        return url;
      }

      const splitedUrl = url.split(".com");

      splitedUrl.splice(1, 0, `.com${policyAndSignature}`);

      return splitedUrl.join("");
    }

    if (policyAndSignature?.policy && policyAndSignature?.signature) {
      return `${url}?policy=${policyAndSignature.policy}&signature=${policyAndSignature.signature}`;
    }

    return url;
  }

  async addComment() {
    this.setState({ disableButton: true });

    try {
      const data = {
        message: this.state.comment,
        opportunityId: this.props.opportunity._id,
        attachments: this.state.files,
      };

      const response = await service.post("/opportunity/comment", data);

      const FileStackService = (
        await import("../../../../services/filestack.service")
      ).default;

      let newComment = response.data;

      let policyAndSignature = null;

      if (newComment.user?.userImageUrl) {
        try {
          const secure = await FileStackService.getFileStackSecreteCodeToUser(
            newComment.user.userImageUrl,
            false,
          );

          policyAndSignature = secure.data;
        } catch (err) {
          console.error("USER IMAGE ERROR:", err);
        }
      }

      if (newComment.attachments?.length) {
        const attachments = await Promise.all(
          newComment.attachments.map(async (file: any) => {
            if (file.policyAndSignature) {
              return file;
            }

            try {
              const secure =
                await FileStackService.getFileStackSecreteCodeToUser(
                  file.url,
                  false,
                );

              return {
                ...file,
                policyAndSignature: secure.data,
              };
            } catch (err) {
               console.log("SECURE FILE ERROR:", err);

              return file;
            }
          }),
        );

        newComment = {
          ...newComment,
          user: {
            ...newComment.user,
            policyAndSignature,
          },
          attachments,
        };
      } else {
        newComment = {
          ...newComment,
          user: {
            ...newComment.user,
            policyAndSignature,
          },
        };
      }

      this.setState((prevState: any) => ({
        comments: [...prevState.comments, newComment],
        comment: "",
        files: [],
        disableButton: false,
      }));
      AlertService.success(t("Comentário adicionado com sucesso"));
    } catch (error) {
      console.error("ERROR:", error);
      AlertService.error(t("Erro ao adicionar comentário"));
      this.setState({
        disableButton: false,
      });
    }
  }

  async updateComment() {
    try {
      const data = {
        message: this.state.currentEditMessage,
        commentId: this.state.currentEditId,
        opportunityId: this.props.opportunity._id,
      };

      const response = await service.put("opportunity/comment", data);

      const FileStackService = (
        await import("../../../../services/filestack.service")
      ).default;

      let updatedComment = response.data;

      let policyAndSignature = null;

      if (updatedComment.user?.userImageUrl) {
        try {
          const secure = await FileStackService.getFileStackSecreteCodeToUser(
            updatedComment.user.userImageUrl,
            false,
          );

          policyAndSignature = secure.data;
        } catch (err) {
          console.error("USER IMAGE ERROR:", err);
        }
      }
      updatedComment = {
        ...updatedComment,
        user: {
          ...updatedComment.user,
          policyAndSignature,
        },
      };
      this.setState((prevState: any) => ({
        comments: prevState.comments.map((comment: any) => {
          if (comment._id !== updatedComment._id) {
            return comment;
          }
          return updatedComment;
        }),
        currentEditId: undefined,
        currentEditMessage: undefined,
      }));
      AlertService.success(t("Comentário atualizado com sucesso"));
    } catch (error) {
      console.error(error);
      AlertService.error(t("Erro ao atualizar comentário"));
    }
  }

  async deleteComment() {
    let data = {
      commentId: this.state.currentEditId,
      opportunityId: this.props.opportunity._id,
    };
    try {
      await service.delete("opportunity/comment", { data });
      let comments = this.state.comments;
      let index = comments.map((e) => e._id).indexOf(data.commentId);
      comments.splice(index, 1);
      this.setState({
        comments: comments,
        currentEditMessage: undefined,
        currentEditId: undefined,
        files: [],
      });
      AlertService.success(t("Comentário excluído com sucesso"));
    } catch (error) {
      console.error(error);
      AlertService.error(t("Erro ao excluir comentário"));
    }
  }

  removeFile = (index: number) => {
    this.setState((prevState: any) => ({
      files: prevState.files.filter(
      (_: any, i: number) => i !== index
    ),
    }));
  };

  render() {
    const currentUser = AuthenticationService.getUser();
    return (
      <div className="ui comments">
        <p className="dividing u-fs-lg">{t("Comentários")}</p>
        {!(this.state.comments.length > 0) && (
          <p className="u-semibold u-fs-md">
            {t("Esta oportunidade ainda não possui nenhum comentário")}.
          </p>
        )}
        {this.state.comments.map((comment, index) => (
          <div key={index} className="comment">
            <div className="avatar">
              <Avatar
                size="small"
                title={comment.user?.displayName || "User Not Found"}
                style={{ border: "1px solid #4F6061" }}
              >
                <img
                  alt={comment.user?.displayName}
                  src={
                    comment.user?.userImageUrl
                      ? this.setUrlFile(
                          comment.user.userImageUrl,
                          comment.user.policyAndSignature,
                        )
                      : avatar
                  }
                  onError={(e: any) => {
                    e.currentTarget.src = avatar;
                  }}
                  className="comment-avatar-image"
                />
              </Avatar>
            </div>
            <div className="content">
              <b className="author">{comment.user.displayName}</b>
              <div className="metadata">
                <div>
                  {comment.updatedAt
                    ? Moment(comment.updatedAt).format(dateFormat)
                    : Moment(comment.createdAt).format(dateFormat)}
                  {comment.updatedBy && (
                    <span className="ml-2 edited-info">
                      • Editado por {comment.updatedBy.displayName}
                    </span>
                  )}
                </div>
                {(AuthenticationService.isRhManager() ||
                  (AuthenticationService.isRh() &&
                    comment.user?._id === currentUser?._id)) && (
                  <div className="actions mt-1">
                    <button
                      className="c-btn c-btn--anchor u-mb-sm"
                      type="button"
                      onClick={() => this.editComment(comment)}
                    >
                      {" "}
                      {t("Editar")}
                    </button>
                  </div>
                )}
              </div>
              {this.state.currentEditId === comment._id ? (
                <div>
                  <textarea
                    className="textarea c-txt__input c-txt__input--area is-resizable"
                    value={this.state.currentEditMessage}
                    onChange={(event) => {
                      this.setState({ currentEditMessage: event.target.value });
                    }}
                  ></textarea>
                  <div>
                    <button
                      className="c-btn c-btn--anchor u-mb-sm mt-2 mr-2"
                      onClick={() => this.updateComment()}
                    >
                      {t("Salvar")}
                    </button>
                    ·
                    <button
                      className="c-btn c-btn--anchor u-mb-sm c-tag--red mt-2 ml-2"
                      onClick={() => this.setState({ isModalVisible: true })}
                    >
                      {t("Excluir")}
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        this.setState({
                          currentEditId: undefined,
                          currentEditMessage: undefined,
                        });
                      }}
                      className="close"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="text">{comment.message}</div>
                  {comment.attachments?.map((file: any) => (
                    <a
                      key={file.url || file.filename}
                      href={
                        file?.policyAndSignature
                          ? this.setUrlFile(file.url, file.policyAndSignature)
                          : file.url
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="comment-file-link"
                    >
                      <div className="file-item">
                        <span className="file-name">
                          {file.filename || "arquivo"}
                        </span>
                      </div>
                    </a>
                  ))}
                </>
              )}
            </div>
          </div>
        ))}
        <div className="comment-input-wrapper">
          <textarea
            className={`${
              this.state.comment ? "textarea" : ""
            } c-txt__input c-txt__input--area is-resizable`}
            value={this.state.comment}
            onChange={this.handleCommentChange}
            placeholder={t("Adicionar Comentário...")}
          />
          {this.state.policyString && this.state.signatureString && (
            <ReactFilestack
              apikey={process.env.REACT_APP_FILESTACK_API}
              componentDisplayMode={{
                type: "button",
                customText: <AttachmentIcon className="attachment-icon" />,
                customClass: "attachment-button",
              }}
              actionOptions={{
                accept: [".pdf", ".docx"],
                maxFiles: 1,
                maxSize: 5 * 1024 * 1024,
              }}
              clientOptions={{
                security: {
                  policy: this.state.policyString,
                  signature: this.state.signatureString,
                },
              }}
              onSuccess={async (result: any) => {
                try {
                  const files = await this.getSecureFiles(result.filesUploaded);

                  this.setState((prevState: any) => ({
                    files: [...prevState.files, ...files],
                  }));

                  AlertService.success(t("Arquivo enviado com sucesso!"));
                } catch (error) {
                  console.log("FILESTACK ERROR:", error);

                  AlertService.error(t("Erro ao enviar arquivo."));
                }
              }}
            />
          )}
        </div>
        {this.state.files.map((file: any, index: number) => (
          <div key={file.url || file.filename} className="file-item">
            📎 {file.filename}
            <button
              onClick={() => this.removeFile(index)}
              className="file-remove"
            >
              ❌
            </button>
          </div>
        ))}

        {(this.state.comment || this.state.files.length > 0) && (
          <button
            disabled={this.state.disableButton}
            className="c-btn c-btn--primary mt-2"
            onClick={this.addComment}
          >
            {t("Adicionar")}
          </button>
        )}
        {this.state.isModalVisible && (
          <DangerModal
            onModalClose={this.onModalClose}
            header="Excluir este comentário?"
            body="Uma vez excluído, este comentário não poderá mais ser recuperado."
            confirmAction={this.deleteComment.bind(this)}
          ></DangerModal>
        )}
      </div>
    );
  }
}
export default CommentComponent;
